export const APP_STORE_LISTING_LIVE = false;
export const APP_STORE_URL = 'https://apps.apple.com/app/id6757096316';
export const EARLY_ACCESS_MAILTO =
  'mailto:support@sticket.in?subject=Sticket%20private%20access';
export const AVAILABILITY_VERIFIED_ON = '2026-08-12';

export function availabilityAccessibleName(visibleLabel: string) {
  return APP_STORE_LISTING_LIVE
    ? `${visibleLabel} in the App Store`
    : `${visibleLabel} (opens your email app)`;
}

export const availability = APP_STORE_LISTING_LIVE
  ? {
      detailHref: APP_STORE_URL,
      primaryLabel: 'Open Sticket',
      detailLabel: 'Open Sticket',
      detailOpensMailApp: false,
    }
  : {
      detailHref: EARLY_ACCESS_MAILTO,
      primaryLabel: 'Invite only',
      detailLabel: 'Ask about Sticket',
      detailOpensMailApp: true,
    };
